function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1553 4.60352H5.15527C4.0507 4.60352 3.15527 5.49895 3.15527 6.60352V20.6035C3.15527 21.7081 4.0507 22.6035 5.15527 22.6035H19.1553C20.2598 22.6035 21.1553 21.7081 21.1553 20.6035V6.60352C21.1553 5.49895 20.2598 4.60352 19.1553 4.60352Z",
    stroke: "#B4B4C4",
    style: (_ref2 = {
      stroke: "#B4B4C4"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.7059 0.7059 0.7686)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1553 2.60352V6.60352",
    stroke: "#B4B4C4",
    style: (_ref3 = {
      stroke: "#B4B4C4"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.7059 0.7059 0.7686)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.15527 2.60352V6.60352",
    stroke: "#B4B4C4",
    style: (_ref4 = {
      stroke: "#B4B4C4"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.7059 0.7059 0.7686)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.15527 10.6035H21.1553",
    stroke: "#B4B4C4",
    style: (_ref5 = {
      stroke: "#B4B4C4"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.7059 0.7059 0.7686)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7c08e414489be393ae550799100cd5e8.svg";
export { ForwardRef as ReactComponent };